import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Tap to Reveal Component
const TapToReveal = ({ isDesktop = false }) => {
  const [tapProgress, setTapProgress] = useState(0);
  const [isRevealed, setIsRevealed] = useState(false);
  const [tapCount, setTapCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showRipple, setShowRipple] = useState(false);
  const [ripplePosition, setRipplePosition] = useState({ x: 0, y: 0 });

  const ads = [
    {
      id: 1,
      title: "Thums Up",
      subtitle: "Limited Time Offer!",
      description: "Buy 1 Get 1 Free",
      cta: "GRAB NOW",
      image: "/assets/thums.png",
      bgImage: "/assets/thumss.jpg",
      bgColor: "from-blue-600 to-red-800",
      tapsRequired: 5
    },
    
  ];

  const [currentAd, setCurrentAd] = useState(ads[0]);

  const handleTap = (e) => {
    if (isRevealed) return;

    // Get tap position for ripple effect
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setRipplePosition({ x, y });
    setShowRipple(true);

    const newTapCount = tapCount + 1;
    setTapCount(newTapCount);
    setIsAnimating(true);

    const progress = (newTapCount / currentAd.tapsRequired) * 100;
    setTapProgress(progress);

    if (newTapCount >= currentAd.tapsRequired) {
      setIsRevealed(true);
      setTapProgress(100);
    }

    // Reset animation states
    setTimeout(() => {
      setIsAnimating(false);
      setShowRipple(false);
    }, 500);
  };

  const resetAd = () => {
    setTapProgress(0);
    setIsRevealed(false);
    setTapCount(0);
    setIsAnimating(false);
    setShowRipple(false);
    // Show next ad
    const currentIndex = ads.findIndex(ad => ad.id === currentAd.id);
    const nextIndex = (currentIndex + 1) % ads.length;
    setCurrentAd(ads[nextIndex]);
  };

  const completeReveal = () => {
    setTapProgress(100);
    setIsRevealed(true);
    setTapCount(currentAd.tapsRequired);
  };

  return (
    <div className="h-full w-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center justify-center overflow-hidden relative">
      {/* Background Image */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url('${currentAd.bgImage || '/assets/thumss.jpg'}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute ${isDesktop ? 'top-12 left-12 text-4xl' : 'top-8 left-8 text-3xl'} animate-bounce opacity-20`}>👆</div>
        <div className={`absolute ${isDesktop ? 'top-20 right-16 text-5xl' : 'top-16 right-12 text-4xl'} animate-pulse opacity-20`}>💎</div>
        <div className={`absolute ${isDesktop ? 'bottom-20 left-20 text-4xl' : 'bottom-24 left-16 text-3xl'} animate-bounce delay-500 opacity-20`}>🎊</div>
        <div className={`absolute ${isDesktop ? 'bottom-12 right-12 text-4xl' : 'bottom-8 right-8 text-3xl'} animate-pulse delay-300 opacity-20`}>🌟</div>
      </div>

      <div className={`${isDesktop ? 'max-w-2xl px-6' : 'max-w-sm px-4'} w-full text-center relative z-10`}>
        {/* Header */}
        <div className={`${isDesktop ? '' : ''} animate-fadeIn`}>
          <h1 className={`text-yellow-300 ${isDesktop ? 'text-lg mt-1' : 'text-lg mt-2'} font-bold mb-1 animate-pulse`}>
            Tap to Reveal
          </h1>
          {/* <h2 className={`text-yellow-300 ${isDesktop ? 'text-md' : 'text-md'} font-semibold mb-1`}>
            Hidden Treasures!
          </h2> */}
          <p className={`text-white/90 ${isDesktop ? ' mb-1 text-sm' : 'text-sm mb-2'} `}>
            Tap multiple times to unlock exclusive offers waiting for you! 
          </p>
        </div>

        {/* Tap Card */}
        <div className={`relative ${isDesktop ? 'mb-1' : 'mb-1'} select-none`}>
          <div className={`bg-white/20 backdrop-blur-lg border border-white/30 rounded-2xl ${isDesktop ? 'p-1' : 'p-1'} shadow-2xl relative overflow-hidden`}>
            {/* Tap Instruction */}
            <div className={`text-center ${isDesktop ? 'mb-1' : 'mb-1'}`}>
              <h3 className={`text-white ${isDesktop ? 'text-sm' : 'text-lg'} font-bold`}>
                Mystery Treasure 🗝️
              </h3>
              <p className={`text-white/90 ${isDesktop ? 'text-sm' : 'text-sm'} `}>
                What amazing offer awaits you?
              </p>
            </div>

            {/* Tap Area */}
            <div 
              className={`relative w-full ${isDesktop ? 'h-36' : 'h-36'} rounded-xl overflow-hidden cursor-pointer select-none transform transition-all duration-200 `}
              onClick={handleTap}
            >
                          {/* Background Image */}
                          <img 
                src={currentAd.bgImage || '/assets/thums.png'} 
                alt="Background" 
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Ripple Effect */}
              {showRipple && (
                <div 
                  className="absolute rounded-full bg-white/50 animate-ping pointer-events-none"
                  style={{
                    left: ripplePosition.x - 25,
                    top: ripplePosition.y - 25,
                    width: 40,
                    height: 40,
                  }}
                />
              )}

              {/* Revealed Content */}
              {/* <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor} flex flex-col items-center justify-center text-white p-2 transition-all duration-500 ${isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-110'}`}>
                <div className={`${isDesktop ? 'mb-1' : 'mb-1'}`}>
                  <div className={`${isDesktop ? 'text-md' : 'text-md'} animate-bounce`}>
                    {currentAd.image}
                  </div>
                </div> */}
                              <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor || 'from-blue-700 to-gray-900'} flex flex-col items-center justify-center text-white p-4 transition-all duration-500 ${isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-110'}`}>
                <div className={`${isDesktop ? 'mb-2' : 'mb-2'}`}>
                  {currentAd.image?.startsWith('/') ? (
                    <img 
                      src={currentAd.image} 
                      alt={currentAd.title} 
                      className={`${isDesktop ? 'w-14 h-14' : 'w-14 h-14'} object-contain`} 
                    />
                  ) : (
                    <div className={`${isDesktop ? 'text-lg' : 'text-lg'} animate-bounce`}>
                      {currentAd.image}
                    </div>
                  )}
                </div>
                {/* <h3 className={`${isDesktop ? 'text-sm' : 'text-sm'} font-medium  text-center`}>
                  {currentAd.title}
                </h3> */}
                {/* <p className={`${isDesktop ? 'text-sm' : 'text-sm'} text-center  opacity-90`}>
                  {currentAd.description}
                </p> */}
                <p
  className={`${
    isDesktop ? 'text-xl' : 'text-xl'
  } text-center font-bold text-yellow-100 drop-shadow-sm tracking-wide`}
>
  {currentAd.description}
</p>
                <p className={`${isDesktop ? 'text-sm' : 'text-sm'} font-semibold  text-center`}>
                  {currentAd.subtitle}
                </p>
                
                {/* <button className={`bg-white text-gray-800 font-bold ${isDesktop ? 'px-4 py-2 text-lg' : 'px-3 py-2 text-base'} rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200`}>
                  {currentAd.cta}
                </button> */}
              </div>

              {/* Overlay that fades away */}
              <div 
                className={`absolute inset-0 bg-gradient-to-r from-gray-800/80 to-gray-600/80 backdrop-blur-sm flex flex-col items-center justify-center text-white transition-all duration-500 ${isRevealed ? 'opacity-0' : 'opacity-100'}`}
                style={{ 
                  opacity: isRevealed ? 0 : Math.max(0.1, 1 - tapProgress / 100)
                }}
              >
                <div className={`${isDesktop ? 'text-lg ' : 'text-lg '} ${isAnimating ? 'animate-bounce' : 'animate-pulse'} transition-all duration-300`}>
                  {tapCount === 0 ? '🔒' : tapProgress >= 100 ? '🎉' : '✨'}
                </div>
                <h3 className={`${isDesktop ? 'text-sm mb-1' : 'text-md mb-1'} font-bold `}>
                  {tapCount === 0 ? 'Mystery Treasure' : tapProgress >= 100 ? 'Unlocked!' : 'Keep Tapping!'}
                </h3>
                <div className="flex items-center space-x-1 ">
                  <div className={`${isDesktop ? 'text-sm ' : 'text-xl'}`}>👆</div>
                  <p className={`${isDesktop ? 'text-sm mb-1' : 'text-base mb-1'} font-semibold`}>
                    {tapCount === 0 ? 'Tap to Unlock' : `${tapCount}/${currentAd.tapsRequired} taps`}
                  </p>
                </div>
                
                {/* Tap Progress Circles */}
                <div className="flex space-x-1 ">
                  {Array.from({ length: currentAd.tapsRequired }, (_, index) => (
                    <div 
                      key={index}
                      className={`${isDesktop ? 'w-2 h-2 mb-1' : 'w-3 h-3 mb-1'} rounded-full transition-all duration-300 ${
                        index < tapCount 
                          ? 'bg-yellow-400 scale-110' 
                          : 'bg-white/30'
                      }`}
                    />
                  ))}
                </div>

                {/* Progress Bar */}
                {/* <div className={`w-3/4 bg-white/30 rounded-full ${isDesktop ? 'h-2' : 'h-2'} overflow-hidden mb-1`}>
                  <div 
                    className={`bg-yellow-400 ${isDesktop ? 'h-2' : 'h-2'} rounded-full transition-all duration-300`}
                    style={{ width: `${tapProgress}%` }}
                  />
                </div> */}
                <p className={`${isDesktop ? 'text-base mb-1' : 'text-sm mb-1'} opacity-80`}>
                  {Math.round(tapProgress)}% unlocked
                </p>
              </div>

              {/* Tap Indicator */}
              {/* {!isRevealed && (
                <div 
                  className={`absolute ${isDesktop ? 'right-6 top-6' : 'right-4 top-4'} bg-yellow-400 rounded-full ${isDesktop ? 'w-10 h-10' : 'w-12 h-12'} shadow-lg flex items-center justify-center z-10 transition-all duration-300 ${isAnimating ? 'scale-125' : 'scale-100'}`}
                >
                  <div className={`${isDesktop ? 'text-sm' : 'text-sm'} ${isAnimating ? 'animate-bounce' : 'animate-pulse'}`}>
                    👆
                  </div>
                </div>
              )} */}
            </div>

            {/* Progress Display */}
            {/* {tapProgress > 0 && (
              <div className={`${isDesktop ? 'mt-1' : 'mt-2'}`}>
                <div className={`bg-gray-200 rounded-full ${isDesktop ? 'h-1' : 'h-2'} overflow-hidden`}>
                  <div 
                    className={`bg-gradient-to-r ${currentAd.bgColor} ${isDesktop ? 'h-1' : 'h-2'} rounded-full transition-all duration-300`}
                    style={{ width: `${tapProgress}%` }}
                  />
                </div>
                <p className={`text-center ${isDesktop ? 'text-sm' : 'text-xs'} text-white/80 mt-1`}>
                  {tapProgress >= 100 ? 'Treasure Unlocked! 🎉' : `${tapCount}/${currentAd.tapsRequired} taps completed`}
                </p>
              </div>
            )} */}
          </div>
        </div>

        {/* Action Buttons */}
        <div className={`space-y-1 ${isDesktop ? 'mb-1' : 'mb-1'}`}>
          {!isRevealed ? (
            <button 
              onClick={completeReveal}
              className={`w-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-bold ${isDesktop ? 'py-1 px-1 text-sm' : 'py-2 px-2 text-base'} rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 animate-pulse`}
            >
              ⚡ Instant Unlock ⚡
            </button>
          ) : (
            <button 
              onClick={resetAd}
              className={`w-full bg-green-500 hover:bg-green-400 text-white font-medium ${isDesktop ? 'py-1 px-1 text-sm' : 'py-2 px-2 text-base'} rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200`}
            >
              🔄 Find More Treasures! 🔄
            </button>
          )}
        </div>

        {/* Footer */}
        <div className="text-center">
          <p className={`text-white/80 ${isDesktop ? 'text-xs mb-1' : 'text-xs mb-1'}`}>
          * Valid for 24 hrs, T&C Applies 
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out;
        }
      `}</style>
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (

    <>


    <Helmet>
           <title>
    Thums Up Campaign | Tap to Reveal Ad Showcase by Bidbox
            </title>
            <meta
              name="description"
              content="See how Thums Up powers Tap to Reveal ads with Bidbox. Explore bold, energetic campaigns that spark curiosity & connect with young audiences."
            />
            {/* <meta
              name="keywords"
              content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
            /> */}
             <link
              rel="canonical"
              href="https://bidbox.ai/tap-to-reveal/thumsup"
            />
            <meta
              name="robots"
              content="max-snippet:-1, max-image-preview:standard"
            />
            <meta name="robots" content="max-video-preview:-1" />
        </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight ">
                  Tap the Thunder. Unlock the Bold.
                  </h1>
                  <span className="bg-purple-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Tap to Reveal
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                ENGAGE YOUR AUDIENCE
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
               
This tap-to-reveal experience builds suspense with every tap. Users tap through each one bringing them closer to bold surprises, whether it’s exclusive vouchers, merch, or limited-time offers. Just plug in your brand assets and rewards, and you’ve got a high-energy, high-impact interactive ready to go.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          tap-to-reveal.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* Tap to Reveal - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                        <div className="mb-6">
                          <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">
                            <TapToReveal isDesktop={false} />
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 tap-to-reveal.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-2 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Tap to Reveal centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center">
                          <div className="w-full max-w-md">
                            <TapToReveal isDesktop={true} />
                          </div>
                        </div>
                                        {/* Additional content placeholders */}
                                        <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>

     <div className="max-w-7xl mx-auto px-4 py-10">
                        <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
                  
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                          {/* Card 1 */}
                          <Link to="/gamification/samsung" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/sama.jpg"
                              alt="Card 1"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Samsung</h2>
                            </div>
                          </Link>
                  
                          {/* Card 2 */}
                          <Link to="/video/mollers" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/moll.avif"
                              alt="Card 2"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Mollers</h2>
                            </div>
                          </Link>
                  
                          {/* Card 3 */}
                          <Link to="/video/tiger" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/tiger.avif"
                              alt="Card 3"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">Tiger</h2>
                            </div>
                          </Link>
                  
                          {/* Card 4 */}
                          <Link to="/drag-to-reveal/abcbeer" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                            <img
                              src="/assets/ab.avif"
                              alt="Card 4"
                              className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                            />
                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <h2 className="text-lg font-semibold">ABC Beer</h2>
                            </div>
                          </Link>
                  
                         
                        </div>
                      </div>
    </>
  );
}

export default App;


// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Play, Pause, Maximize2, Download, Share2, Eye, Settings, Monitor, Smartphone, Gift, Sparkles, Zap, Target, RotateCcw } from 'lucide-react';

// // Tap to Reveal Component
// const TapToReveal = ({ isDesktop = false }) => {
//   const [tapProgress, setTapProgress] = useState(0);
//   const [isRevealed, setIsRevealed] = useState(false);
//   const [tapCount, setTapCount] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [showRipple, setShowRipple] = useState(false);
//   const [ripplePosition, setRipplePosition] = useState({ x: 0, y: 0 });

//   const ads = [
//     {
//       id: 1,
//       title: "Thums Up",
//       subtitle: "Limited Time Offer!",
//       description: "Crack open the thunder – Refresh your day with an icy cold Thums Up!",
//       cta: "GRAB NOW",
      // image: "/assets/thums.png",
      // bgImage: "/assets/thumss.jpg",
//       tapsRequired: 5
//     },
   
//   ];

//   const [currentAd, setCurrentAd] = useState(ads[0]);

//   const handleTap = (e) => {
//     if (isRevealed) return;

//     // Get tap position for ripple effect
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     const y = e.clientY - rect.top;
//     setRipplePosition({ x, y });
//     setShowRipple(true);

//     const newTapCount = tapCount + 1;
//     setTapCount(newTapCount);
//     setIsAnimating(true);

//     const progress = (newTapCount / currentAd.tapsRequired) * 100;
//     setTapProgress(progress);

//     if (newTapCount >= currentAd.tapsRequired) {
//       setIsRevealed(true);
//       setTapProgress(100);
//     }

//     // Reset animation states
//     setTimeout(() => {
//       setIsAnimating(false);
//       setShowRipple(false);
//     }, 500);
//   };

//   const resetAd = () => {
//     setTapProgress(0);
//     setIsRevealed(false);
//     setTapCount(0);
//     setIsAnimating(false);
//     setShowRipple(false);
//     // Show next ad
//     const currentIndex = ads.findIndex(ad => ad.id === currentAd.id);
//     const nextIndex = (currentIndex + 1) % ads.length;
//     setCurrentAd(ads[nextIndex]);
//   };

//   const completeReveal = () => {
//     setTapProgress(100);
//     setIsRevealed(true);
//     setTapCount(currentAd.tapsRequired);
//   };

//   return (
//     <div className="h-full w-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center justify-center overflow-hidden relative">
//       {/* Background Image */}
      // <div 
      //   className="absolute inset-0 opacity-30"
      //   style={{
      //     backgroundImage: `url('${currentAd.bgImage || '/assets/thumss.jpg'}')`,
      //     backgroundSize: 'cover',
      //     backgroundPosition: 'center'
      //   }}
      // />

//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className={`absolute ${isDesktop ? 'top-12 left-12 text-4xl' : 'top-8 left-8 text-3xl'} animate-bounce opacity-20`}>👆</div>
//         <div className={`absolute ${isDesktop ? 'top-20 right-16 text-5xl' : 'top-16 right-12 text-4xl'} animate-pulse opacity-20`}>💎</div>
//         <div className={`absolute ${isDesktop ? 'bottom-20 left-20 text-4xl' : 'bottom-24 left-16 text-3xl'} animate-bounce delay-500 opacity-20`}>🎊</div>
//         <div className={`absolute ${isDesktop ? 'bottom-12 right-12 text-4xl' : 'bottom-8 right-8 text-3xl'} animate-pulse delay-300 opacity-20`}>🌟</div>
//       </div>

//       <div className={`${isDesktop ? 'max-w-2xl px-6' : 'max-w-sm px-4'} w-full text-center relative z-10`}>
//         {/* Header */}
//         <div className={`${isDesktop ? 'mb-1' : 'mb-2'} animate-fadeIn`}>
//           <h1 className={`text-white ${isDesktop ? 'text-2xl mt-2' : 'text-2xl mt-4'} font-bold mb-1 animate-pulse`}>
//             Tap to Reveal
//           </h1>
//           <h2 className={`text-yellow-300 ${isDesktop ? 'text-xl' : 'text-xl'} font-semibold mb-1`}>
//             Hidden Treasures!
//           </h2>
//           <p className={`text-white/90 ${isDesktop ? 'text-base' : 'text-sm'} mb-1`}>
//             Tap multiple times to unlock exclusive offers waiting for you! 
//           </p>
//         </div>

//         {/* Tap Card */}
//         <div className={`relative ${isDesktop ? 'mb-2' : 'mb-2'} select-none`}>
//           <div className={`bg-white/20 backdrop-blur-lg border border-white/30 rounded-2xl ${isDesktop ? 'p-6' : 'p-4'} shadow-2xl relative overflow-hidden`}>
//             {/* Tap Instruction */}
//             <div className={`text-center ${isDesktop ? 'mb-1' : 'mb-1'}`}>
//               <h3 className={`text-white ${isDesktop ? 'text-2xl' : 'text-xl'} font-bold mb-1`}>
//                 Mystery Treasure 🗝️
//               </h3>
//               <p className={`text-white/90 ${isDesktop ? 'text-base' : 'text-sm'} mb-1`}>
//                 What amazing offer awaits you?
//               </p>
//             </div>

//             {/* Tap Area */}
//             <div 
//               className={`relative w-full ${isDesktop ? 'h-52' : 'h-48'} rounded-xl overflow-hidden cursor-pointer select-none transform transition-all duration-200 ${isAnimating ? 'scale-95' : 'scale-100'} hover:scale-105`}
//               onClick={handleTap}
//             >
              // {/* Background Image */}
              // <img 
              //   src={currentAd.bgImage || '/assets/thumss.jpg'} 
              //   alt="Background" 
              //   className="absolute inset-0 w-full h-full object-cover"
              // />

//               {/* Ripple Effect */}
//               {showRipple && (
//                 <div 
//                   className="absolute rounded-full bg-white/50 animate-ping pointer-events-none"
//                   style={{
//                     left: ripplePosition.x - 25,
//                     top: ripplePosition.y - 25,
//                     width: 50,
//                     height: 50,
//                   }}
//                 />
//               )}

//               {/* Revealed Content */}
              // <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor || 'from-blue-700 to-gray-900'} flex flex-col items-center justify-center text-white p-4 transition-all duration-500 ${isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-110'}`}>
              //   <div className={`${isDesktop ? 'mb-1' : 'mb-1'}`}>
              //     {currentAd.image?.startsWith('/') ? (
              //       <img 
              //         src={currentAd.image} 
              //         alt={currentAd.title} 
              //         className={`${isDesktop ? 'w-16 h-16' : 'w-16 h-16'} object-contain`} 
              //       />
              //     ) : (
              //       <div className={`${isDesktop ? 'text-4xl' : 'text-4xl'} animate-bounce`}>
              //         {currentAd.image}
              //       </div>
              //     )}
              //   </div>
//                 <h3 className={`${isDesktop ? 'text-lg' : 'text-lg'} font-bold mb-1 text-center`}>
//                   {currentAd.title}
//                 </h3>
//                 <p className={`${isDesktop ? 'text-md' : 'text-base'} font-semibold mb-1 text-center`}>
//                   {currentAd.subtitle}
//                 </p>
//                 <p className={`${isDesktop ? 'text-base' : 'text-sm'} text-center mb-1 opacity-90`}>
//                   {currentAd.description}
//                 </p>
//                 {/* <button className={`bg-white text-gray-800 font-bold ${isDesktop ? 'px-2 py-1 text-lg' : 'px-2 py-2 text-base'} rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200`}>
//                   {currentAd.cta}
//                 </button> */}
//               </div>

//               {/* Overlay that fades away */}
//               <div 
//                 className={`absolute inset-0 bg-gradient-to-r from-gray-800/80 to-gray-600/80 backdrop-blur-sm flex flex-col items-center justify-center text-white transition-all duration-500 ${isRevealed ? 'opacity-0' : 'opacity-100'}`}
//                 style={{ 
//                   opacity: isRevealed ? 0 : Math.max(0.1, 1 - tapProgress / 100)
//                 }}
//               >
//                 <div className={`${isDesktop ? 'text-4xl mb-2' : 'text-4xl mb-2'} ${isAnimating ? 'animate-bounce' : 'animate-pulse'} transition-all duration-300`}>
//                   {tapCount === 0 ? '🔒' : tapProgress >= 100 ? '🎉' : '✨'}
//                 </div>
//                 <h3 className={`${isDesktop ? 'text-2xl' : 'text-xl'} font-bold mb-1`}>
//                   {tapCount === 0 ? 'Mystery Treasure' : tapProgress >= 100 ? 'Unlocked!' : 'Keep Tapping!'}
//                 </h3>
//                 <div className="flex items-center space-x-1 mb-1">
//                   <div className={`${isDesktop ? 'text-xl' : 'text-xl'}`}>👆</div>
//                   <p className={`${isDesktop ? 'text-xl' : 'text-base'} font-semibold`}>
//                     {tapCount === 0 ? 'Tap to Unlock' : `${tapCount}/${currentAd.tapsRequired} taps`}
//                   </p>
//                 </div>
                
//                 {/* Tap Progress Circles */}
//                 <div className="flex space-x-1 mb-2">
//                   {Array.from({ length: currentAd.tapsRequired }, (_, index) => (
//                     <div 
//                       key={index}
//                       className={`${isDesktop ? 'w-4 h-4' : 'w-3 h-3'} rounded-full transition-all duration-300 ${
//                         index < tapCount 
//                           ? 'bg-yellow-400 scale-110' 
//                           : 'bg-white/30'
//                       }`}
//                     />
//                   ))}
//                 </div>

//                 {/* Progress Bar */}
//                 <div className={`w-3/4 bg-white/30 rounded-full ${isDesktop ? 'h-2' : 'h-2'} overflow-hidden mb-1`}>
//                   <div 
//                     className={`bg-yellow-400 ${isDesktop ? 'h-2' : 'h-2'} rounded-full transition-all duration-300`}
//                     style={{ width: `${tapProgress}%` }}
//                   />
//                 </div>
//                 <p className={`${isDesktop ? 'text-base' : 'text-sm'} opacity-80`}>
//                   {Math.round(tapProgress)}% unlocked
//                 </p>
//               </div>

//               {/* Tap Indicator */}
//               {!isRevealed && (
//                 <div 
//                   className={`absolute ${isDesktop ? 'right-6 top-6' : 'right-4 top-4'} bg-yellow-400 rounded-full ${isDesktop ? 'w-14 h-14' : 'w-12 h-12'} shadow-lg flex items-center justify-center z-10 transition-all duration-300 ${isAnimating ? 'scale-125' : 'scale-100'}`}
//                 >
//                   <div className={`${isDesktop ? 'text-xl' : 'text-xl'} ${isAnimating ? 'animate-bounce' : 'animate-pulse'}`}>
//                     👆
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Progress Display */}
//             {tapProgress > 0 && (
//               <div className={`${isDesktop ? 'mt-6' : 'mt-4'}`}>
//                 <div className={`bg-gray-200 rounded-full ${isDesktop ? 'h-3' : 'h-2'} overflow-hidden`}>
//                   <div 
//                     className={`bg-gradient-to-r ${currentAd.bgColor || 'from-blue-700 to-gray-900'} ${isDesktop ? 'h-3' : 'h-2'} rounded-full transition-all duration-300`}
//                     style={{ width: `${tapProgress}%` }}
//                   />
//                 </div>
//                 <p className={`text-center ${isDesktop ? 'text-sm' : 'text-xs'} text-white/80 mt-2`}>
//                   {tapProgress >= 100 ? 'Treasure Unlocked! 🎉' : `${tapCount}/${currentAd.tapsRequired} taps completed`}
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className={`space-y-1 ${isDesktop ? 'mb-1' : 'mb-1'}`}>
//           {!isRevealed ? (
//             <button 
//               onClick={completeReveal}
//               className={`w-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-bold ${isDesktop ? 'py-1 px-2 text-lg' : 'py-1 px-2 text-base'} rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 animate-pulse`}
//             >
//               ⚡ Instant Unlock ⚡
//             </button>
//           ) : (
//             <button 
//               onClick={resetAd}
//               className={`w-full bg-green-500 hover:bg-green-400 text-white font-bold ${isDesktop ? 'py-1 px-2 text-lg' : 'py-1 px-2 text-base'} rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200`}
//             >
//               🔄 Find More Treasures! 🔄
//             </button>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="text-center">
//           <p className={`text-white/80 ${isDesktop ? 'text-base' : 'text-sm'}`}>
//             * Limited time treasures. Tap to unlock exclusive deals!
//           </p>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default function TapRevealMockup() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);

//     return (
//         <div className="mt-14  min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-pink-50 p-4 lg:p-6">
//             {/* Header */}
//             <div className="mb-6 lg:mb-8">
//                 <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
//                     <div>
//                         <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Tap-to-Reveal Campaign</h1>
//                         <p className="text-gray-600 text-sm lg:text-base">Interactive mystery deal ad with tap gesture</p>
//                     </div>
//                     <div className="flex items-center gap-3">
//                         <button className="px-3 py-2 lg:px-4 lg:py-2 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2 text-sm lg:text-base">
//                             <Settings className="h-4 w-4" />
//                             Settings
//                         </button>
//                         <button className="px-3 py-2 lg:px-4 lg:py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center gap-2 text-sm lg:text-base">
//                             <Share2 className="h-4 w-4" />
//                             Share
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6">
//                 {/* Left Sidebar - Project Info */}
//                 <div className="lg:col-span-1 order-2 lg:order-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-6">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center">
//                                 <Gift className="h-5 w-5 lg:h-6 lg:w-6 text-white" />
//                             </div>
//                             <div>
//                                 <h2 className="text-base lg:text-lg font-semibold text-gray-900">Mystery Deals</h2>
//                                 <p className="text-xs lg:text-sm text-gray-500">ID: 789123</p>
//                             </div>
//                         </div>
                        
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Status</span>
//                                 <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">Active</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Campaign</span>
//                                 <span className="text-xs lg:text-sm text-gray-900">Holiday 2024</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Updated</span>
//                                 <span className="text-xs lg:text-sm text-gray-900">1 hour ago</span>
//                             </div>
//                         </div>

//                         <button className="w-full mt-4 text-purple-600 hover:text-purple-700 text-xs lg:text-sm font-medium">
//                             View Campaign Analytics
//                         </button>
//                     </div>

//                     {/* Quick Actions */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
//                         <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
//                         <div className="space-y-3">
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Download className="h-4 w-4" />
//                                 Export Creative
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Copy className="h-4 w-4" />
//                                 Copy Ad Tag
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Maximize2 className="h-4 w-4" />
//                                 Fullscreen Test
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Center Content - Preview Area */}
//                 <div className="lg:col-span-2 order-1 lg:order-2">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
//                         {/* Device Toggle */}
//                         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
//                             <div className="flex items-center gap-2">
//                                 <h3 className="text-base lg:text-lg font-semibold text-gray-900">Interactive Preview</h3>
//                                 <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" />
//                             </div>
//                             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//                                 {[
//                                     { name: 'Mobile', icon: Smartphone },
//                                     { name: 'Desktop', icon: Monitor }
//                                 ].map(({ name, icon: Icon }) => (
//                                     <button
//                                         key={name}
//                                         className={`px-2 py-1 lg:px-3 lg:py-2 rounded-md text-xs lg:text-sm font-medium transition-all flex items-center gap-1 lg:gap-2 ${
//                                             selectedDevice === name
//                                                 ? 'bg-white text-purple-600 shadow-sm'
//                                                 : 'text-gray-600 hover:text-gray-900'
//                                         }`}
//                                         onClick={() => setSelectedDevice(name)}
//                                     >
//                                         <Icon className="h-3 w-3 lg:h-4 lg:w-4" />
//                                         {name}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Navigation */}
//                         <div className="flex items-center justify-between mb-6">
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm">
//                                 <ChevronLeft className="h-4 w-4" />
//                                 Previous Ad
//                             </button>
//                             <div className="flex items-center gap-2">
//                                 <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                             </div>
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm">
//                                 Next Ad
//                                 <ChevronRight className="h-4 w-4" />
//                             </button>
//                         </div>

//                         {/* Preview Container */}
//                         <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 lg:p-8 min-h-[400px] lg:min-h-[600px] flex items-center justify-center">
//                             {/* Device Frame */}
//                             <div className="relative">
//                                 {selectedDevice === 'Mobile' ? (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-3xl blur-xl"></div>
//                                         <div className="relative bg-gray-900 rounded-3xl p-2 shadow-2xl">
//                                             <div className="bg-black rounded-2xl overflow-hidden">
//                                                 <div className="w-[280px] h-[500px] lg:w-[300px] lg:h-[560px] relative">
//                                                     <TapToReveal isDesktop={false} />
//                                                 </div>
//                                             </div>
//                                             <div className="w-16 h-1 lg:w-20 lg:h-1 bg-gray-600 rounded-full mx-auto mt-2"></div>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-xl blur-xl"></div>
//                                         <div className="relative bg-white rounded-xl shadow-2xl p-4">
//                                             <div className="bg-gray-100 rounded-lg p-2">
//                                                 <div className="w-[320px] h-[600px] lg:w-[500px] lg:h-[700px] bg-black rounded overflow-hidden relative">
//                                                     <TapToReveal isDesktop={true} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Interaction Guide */}
//                         <div className="mt-6 bg-purple-50 rounded-lg p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-6 h-6 lg:w-8 lg:h-8 bg-purple-600 text-white rounded-full flex items-center justify-center">
//                                     <Sparkles className="h-3 w-3 lg:h-4 lg:w-4" />
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-purple-900 text-sm lg:text-base">Interactive Elements</h4>
//                                     <p className="text-xs lg:text-sm text-purple-700">Tap multiple times on the mystery card to reveal exclusive deals and offers</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Sidebar - Details */}
//                 <div className="lg:col-span-1 order-3">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-6">
//                         <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-4">Creative Details</h3>
                        
//                         <div className="space-y-3 lg:space-y-4">
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Dimensions</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">320 × 600px</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Format</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">Interactive HTML5</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Gesture</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">Tap Reveal</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">File Size</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">2.1</div>
//                                 </div>
//                         </div>
//                     </div>

//                     {/* Performance Metrics */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Engagement Stats</h3>
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Tap Rate</span>
//                                 <span className="text-sm font-semibold text-green-600">8.3%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Tap Reveal Rate</span>
//                                 <span className="text-sm font-semibold text-blue-600">6.2%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Click Through</span>
//                                 <span className="text-sm font-semibold text-purple-600">4.1%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Interaction Flow */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Interaction Flow</h3>
//                         <div className="space-y-3">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Mystery card display</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Tap gesture detection</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Progressive reveal</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-green-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Deal completion</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

